/**
 * Parses an int64-cents money string off the wire into a number, defaulting a
 * missing, empty, or non-numeric value to 0.
 *
 * The API serializes int64 money fields (`spendCents`, `amountCents`, …) as
 * decimal strings, so any caller that sums or scales them needs a NaN-safe
 * parse — an absent field must read as $0 rather than poison the arithmetic
 * (and `NaN / 100` would render as "$NaN"). Shared single source of truth for
 * the spend/usage/overhead cards that all parse the same wire shape.
 */
export function cents(s?: string): number {
  const n = parseInt(s ?? '0', 10);
  return Number.isNaN(n) ? 0 : n;
}
